// These CSS classes don't exist in our codebase, but they might still exist in DB faq entries
// See 78394e2580844b3b56ce9da74e76e1b07e82f069
$(function () {
    $(document).on('click', '.js-faq-open-window', function (e) {
        const windowName = $(this).data('window-name');
        window.g_openWindow(this.href, 420, 420, windowName, true);
        e.preventDefault();
    });
    $(document).on('click', '.js-faq-open-help-window', function (e) {
        openHelpWindow(this.href);
        e.preventDefault();
    });
    function openHelpWindow(page) {
        window.g_openWindow(page, 500, 500, 'newPropWin', 'yes', 'no', 'no', 'no', 700, 50);
    }
});
